/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleCrossSystemDailyRowData
 */
export interface GoogleCrossSystemDailyRowData {
    /**
     * 
     * @type {Date}
     * @memberof GoogleCrossSystemDailyRowData
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    paidSpend?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    paidClicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    paidImpressions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    organicClicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    organicImpressions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    sessions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    engagedSessions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    ga4Purchases?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    ga4Revenue?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    erpOrders?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    erpTurnover?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    datixoOrderEvents?: string;
}

/**
 * Check if a given object implements the GoogleCrossSystemDailyRowData interface.
 */
export function instanceOfGoogleCrossSystemDailyRowData(value: object): value is GoogleCrossSystemDailyRowData {
    return true;
}

export function GoogleCrossSystemDailyRowDataFromJSON(json: any): GoogleCrossSystemDailyRowData {
    return GoogleCrossSystemDailyRowDataFromJSONTyped(json, false);
}

export function GoogleCrossSystemDailyRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleCrossSystemDailyRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'paidSpend': json['paidSpend'] == null ? undefined : json['paidSpend'],
        'paidClicks': json['paidClicks'] == null ? undefined : json['paidClicks'],
        'paidImpressions': json['paidImpressions'] == null ? undefined : json['paidImpressions'],
        'organicClicks': json['organicClicks'] == null ? undefined : json['organicClicks'],
        'organicImpressions': json['organicImpressions'] == null ? undefined : json['organicImpressions'],
        'sessions': json['sessions'] == null ? undefined : json['sessions'],
        'engagedSessions': json['engagedSessions'] == null ? undefined : json['engagedSessions'],
        'ga4Purchases': json['ga4Purchases'] == null ? undefined : json['ga4Purchases'],
        'ga4Revenue': json['ga4Revenue'] == null ? undefined : json['ga4Revenue'],
        'erpOrders': json['erpOrders'] == null ? undefined : json['erpOrders'],
        'erpTurnover': json['erpTurnover'] == null ? undefined : json['erpTurnover'],
        'datixoOrderEvents': json['datixoOrderEvents'] == null ? undefined : json['datixoOrderEvents'],
    };
}

export function GoogleCrossSystemDailyRowDataToJSON(json: any): GoogleCrossSystemDailyRowData {
    return GoogleCrossSystemDailyRowDataToJSONTyped(json, false);
}

export function GoogleCrossSystemDailyRowDataToJSONTyped(value?: GoogleCrossSystemDailyRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'paidSpend': value['paidSpend'],
        'paidClicks': value['paidClicks'],
        'paidImpressions': value['paidImpressions'],
        'organicClicks': value['organicClicks'],
        'organicImpressions': value['organicImpressions'],
        'sessions': value['sessions'],
        'engagedSessions': value['engagedSessions'],
        'ga4Purchases': value['ga4Purchases'],
        'ga4Revenue': value['ga4Revenue'],
        'erpOrders': value['erpOrders'],
        'erpTurnover': value['erpTurnover'],
        'datixoOrderEvents': value['datixoOrderEvents'],
    };
}

